<template>
  <div class="profile">
    <div class="profile-label unselectable">
      <span>{{title}}</span>
    </div>

    <div tabindex="-1" class="profile-edit" >
      <div :class="editBorder">
        <div tabindex="-1" class="input-field-parent" style="outline: none;">
          <div class="input-field selectable-text" :contenteditable="editable" ref="input" 
            @keyup.escape="reset" 
            @keydown.enter="update"
            @keydown="onKeyDown"
            :id="'profile-item-' + this.uid"
            v-html="valueText"
          ></div>
        </div>
        <span class="input-append-parent" v-if="!readonly">

          <div v-if="editable" 
            class="input-append unselectable"
            :title="$t('done_btn')" 
            v-on:click="update"
          >
            <v-icon color="primary">check</v-icon>
          </div>
          <div v-else 
            class="input-append unselectable" 
            :title="$t('edit_btn')" 
            v-on:click="edit"
          >
            <v-icon>edit</v-icon>
          </div>

        </span>
      </div>
      <div class="profile-edit-bottom"></div>
    </div>

    <div v-if="qrcode" @click="qrcodeDialog=true">
      <qrcode-vue :value="'id:'+value" size="40" level="H" className="sw--pa-qrcode" />

      <v-dialog v-model="qrcodeDialog" max-width="256">
        <v-card>
          <div style="width: 256px;height: 256px;overflow: hidden;">
            <qrcode-vue :value="'id:'+value" size="256" level="H" />
          </div>
        </v-card>
      </v-dialog>
    </div>

  </div>  
</template>

<script>
  import QrcodeVue from 'qrcode.vue'

  function placeCaretAtEnd(el) {
      el.focus()
      if (typeof window.getSelection != "undefined"
              && typeof document.createRange != "undefined") {
          var range = document.createRange()
          range.selectNodeContents(el)
          range.collapse(false)
          var sel = window.getSelection()
          sel.removeAllRanges()
          sel.addRange(range)
      } else if (typeof document.body.createTextRange != "undefined") {
          var textRange = document.body.createTextRange()
          textRange.moveToElementText(el)
          textRange.collapse(false)
          textRange.select()
      }
  }

  function isAlphaNum(code) {
    if (code > 47 && code < 58) // numeric (0-9)
      return true
    if (code > 64 && code < 91) // upper alpha (A-Z)
      return true
    if (code > 96 && code < 123) // lower alpha (a-z)
      return true
    return false
  }

  export default {
    name: 'profile-item',
    components: {
      QrcodeVue
    },
    props: {
      title: {
        type: String,
        required: true
      },
      value: {
        type: String,
        required: true
      },
      valueLength: {
        type: Number,
        default: 0
      },
      readonly: {
        type: Boolean,
        default: false
      },
      qrcode: {
        type: Boolean,
        default: false
      },
      onChanged: {
        type: Function,
        required: false
      }
    },
    data: () => ({
      editable: false,
      qrcodeDialog: false,
      uid: 0
    }),
    computed: {
      editBorder() {
        return this.editable ? 'profile-edit-inner edit-border' : 'profile-edit-inner edit-border-none'
      },
      valueText() {
        return this.safeTextWithEmoji(this.value)
      }
    },
    methods: {
      update(e) {
        let value = this.getText(this.$refs.input)
        if (this.onChanged !== undefined)
          this.onChanged(value)

        this.editable = false
      },
      edit() {
        this.editable = true
        this.$nextTick(() => {
          placeCaretAtEnd(this.$refs.input)
        })
      },
      reset() {
        this.$refs.input.innerHTML = this.valueText
        this.editable = false
      },
      getText(ta) {
        let text = ''
        ta.childNodes.forEach(el => {
          if (el.nodeName == 'IMG') {
            text += String.fromCodePoint(parseInt(el.dataset.codepoints, 16))
          } else if (el.nodeName == 'BR') {
            text += '\n'
          } else {
            text += el.textContent
          }
        })
        return text.trim()
      },
      onKeyDown(e) {
        console.log(this.valueLength)
        let value = this.getText(this.$refs.input)
        if (this.valueLength > 0 && value.length > this.valueLength && isAlphaNum(e.which)) {
          e.preventDefault()
          return
        }
      }
    },
    mounted() {
      this.uid = this.$vnode.key
    }
  }
</script>

<style>
  .sw--pa-qrcode {
    position: absolute;
    margin-right: 8px;
    right: 0px;
    top: calc(50% - 20px);
    cursor: pointer;
    height: 40px;
    width: 40px;
    z-index: 10;
  }
  .sw--pa-qrcode:hover {
    /*transform: scale(2.5);
    right: 20px;*/
    opacity: 0.8;
  }

  .profile { 
    padding: 6px 10px 4px 10px;
    margin-bottom: 1px;
    /* background-color: var(--v-baseBackground-base); */
    /*box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);*/
    border-bottom: thin solid var(--divider-color);
    flex: none;
    outline: none;
    position: relative; 
  }
  .profile-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    flex: 1 1 auto;
    line-height: normal;
  }
  .profile-label span { 
    color: var(--secondary-text);
    font-size: 12px;
  }

  [contenteditable]:focus { 
    outline: none; 
  }

  .profile-edit {
    position: relative;
    word-break: break-word;
    outline: none;
  }
  .edit-border-none {
    border-bottom: 2px solid transparent;
  }
  .edit-border {
    border-bottom: 2px solid var(--v-primary-base);
  }

  .profile-edit-inner {
    display: flex;
    align-items: flex-start;
    z-index: 2;
    position: relative;
  }

  .input-field-parent {
    position: relative;
    flex: 1;
    display: flex;
    overflow: hidden;
    padding-right: 0px;
  }

  .input-append-parent {
    padding-top: 0px;
    flex: none;
    position: relative;
    width: 24px;
    cursor: pointer;
  }
  .input-append {
    right: 0;
    position: absolute;
    top: 3px;
  }

  .profile-edit-bottom {
    position: absolute;
    top: 0;
    width: 100%;
  }

  .input-field {
    margin: 6px 0;
    min-width: 5px;
    padding: 0;
    font-size: 15px;
    line-height: 16px;
    min-height: 18px;
    position: relative;
    width: 100%;
    user-select: text;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .selectable-text {
    user-select: text;
  }
  .unselectable {
    user-select: none;
  }
</style>

